import {
  Component,
  Input,
  Output,
  ElementRef,
  EventEmitter,
} from "@angular/core";
const THEMES = {
  DARK: "DARK",
};

@Component({
  selector: "icn-switch-toggle",
  templateUrl: "./switchToggle.component.html",
  styleUrls: ["./switchToggle.component.scss"],
})
export class SwitchToggleComponent {
  @Input()
  isActive: boolean;

  @Input()
  beforeToggle: () => Promise<boolean> = null;

  @Input()
  theme: string = "";

  @Output()
  isActiveChange = new EventEmitter<boolean>();

  toggle(event) {
    this.canToggle().then((result) => {
      if (result) {
        this.isActive = !this.isActive;
        this.isActiveChange.emit(this.isActive);
      }
    });
  }

  canToggle() {
    if (!this.beforeToggle) {
      return Promise.resolve(true);
    }

    return this.beforeToggle().catch((x) => {
      return false;
    });
  }
}
